import clsx from 'clsx';
import {
  RoundPlayButton,
  RoundRefreshButton,
  RoundCloseButton,
} from '@/components';

interface ToolbarProps {
  className?: string;
  onPlay?: () => void;
  playDisabled?: boolean;
  onRefresh?: () => void;
  onClose?: () => void;
  hintPlay?: boolean;
}

export const Toolbar = ({
  className,
  onPlay,
  playDisabled = false,
  onRefresh,
  onClose,
  hintPlay = false,
}: ToolbarProps) => {
  return (
    <div
      className={clsx(
        'flex w-full justify-center items-center gap-3',
        className,
      )}
    >
      {onPlay && (
        <RoundPlayButton
          role="button"
          ariaLabel="Play sound"
          size="sm"
          color="white"
          onClick={onPlay}
          pressHint={hintPlay}
          disabled={playDisabled}
        />
      )}

      {onRefresh && (
        <RoundRefreshButton
          role="button"
          ariaLabel="Reset handwriting"
          size="sm"
          color="white"
          onClick={onRefresh}
        />
      )}

      {onClose && (
        <RoundCloseButton
          role="button"
          ariaLabel="Close"
          size="sm"
          color="red"
          onClick={onClose}
        />
      )}
    </div>
  );
};
